import instance from '../api'; // Using your configured axios instance
import { RuleSet } from '../../rbac/engine';
import { getEmptyRuleset } from '../../rbac/rolePacks';

export interface RoleResponse {
  role: string;
  allow: string[];
  deny: string[];
}

class RolesService {
  /**
   * Fetches the user's roles and permissions from the API
   * @returns A Promise that resolves to the user's roles and permissions
   */
  async getUserRoles(): Promise<RuleSet> {
    try {
      const response = await instance.get<RoleResponse>('AllyRoles');

      // Validate response
      if (!response || !response.data || typeof response.data == 'string') {
        console.warn('Invalid response from roles API - no data received');
        return getEmptyRuleset();
      }

      // Validate response structure
      const { allow: allowArray, deny: denyArray } = response.data;

      // Ensure allow and deny arrays exist and are valid
      const allow = Array.isArray(allowArray)
        ? allowArray.filter((item) => typeof item === 'string' && item.trim().length > 0)
        : [];

      const deny = Array.isArray(denyArray)
        ? denyArray.filter((item) => typeof item === 'string' && item.trim().length > 0)
        : [];

      // If both arrays are empty, there's likely an issue with the API response
      if (allow.length === 0 && deny.length === 0) {
        console.warn('API returned empty or invalid allow and deny lists - using empty ruleset');
        return getEmptyRuleset();
      }

      return { allow, deny };
    } catch (error) {
      console.error('Failed to fetch user roles:', error);
      // Return empty ruleset on API error
      return getEmptyRuleset();
    }
  }
}

export default new RolesService();
